export enum IBKROrderType {
  LMT = 'LMT',
  MKT = 'MKT',
  MIDPRICE = 'MIDPRICE',
}

export class IBKROrderTypeHelper {
  static names: Map<IBKROrderType, string> = new Map<IBKROrderType, string>([
    [IBKROrderType.LMT, 'Limit'],
    [IBKROrderType.MIDPRICE, 'MidPrice'],
    [IBKROrderType.MKT, 'Market']
  ])
}